import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledBoxTerm = styled(Box)(({ theme }) => ({
  padding: '5px',
  width: '100%',
  backgroundColor: theme.palette.grey[300],
  color: theme.palette.text.primary,
}))

export const StyledLabelHeading = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  paddingBottom: theme.spacing(2),
}))
